import { RevisionAnnotations } from "~/types/RevisionAnnotation";

export const usePopulateAnnotationMaps = (annotations: RevisionAnnotations) => {
  const annotationMap: { [key: number]: RevisionAnnotations } = {};
  const annotationParagraphMap: { [key: string]: RevisionAnnotations } = {};
  const endLineAnnotations: { [key: string]: RevisionAnnotations } = {};

  for (var annotation of annotations) {
    if (
      annotation.tokenGlobalPositions?.length > 0 &&
      annotation.isEndLine != true &&
      annotation.isStartLine != true
    ) {
      if (annotation.tokenGlobalPositions.length == 0) {
        continue;
      }

      var lastTokenPosition = Math.max(...annotation.tokenGlobalPositions);

      if (!annotationMap[lastTokenPosition]) {
        annotationMap[lastTokenPosition] = [];
      }

      annotationMap[lastTokenPosition].push(annotation);
    }

    if (annotation.isStartLine == true) {
      var position = annotation.lastTokenGlobalPosition;

      if (position != undefined) {
        if (!annotationMap[position]) {
          annotationMap[position] = [];
        }

        annotationMap[position].push(annotation);
      }
    }

    // If the annotation has a paragraph and isEndLine we need to attach it to the last token
    // BUT if the endLine annotation has force inline off and a long comment hten we don't attach it.
    if (annotation.paragraphId && annotation.isEndLine) {
      if (!endLineAnnotations[annotation.paragraphId]) {
        endLineAnnotations[annotation.paragraphId] = [];
      }
      if (
        annotation.forceInline == true ||
        useIsAnnotationCommentLong(annotation) == false
      ) {
        endLineAnnotations[annotation.paragraphId].push(annotation);
      }
    }

    // If the annotation .isEndLine OR the annotation is endLine and long
    if (
      annotation.paragraphId &&
      annotation.isStartLine != true &&
      (annotation.isEndLine != true ||
        (annotation.isEndLine &&
          useIsAnnotationCommentLong(annotation) == true))
    ) {
      if (!annotationParagraphMap[annotation.paragraphId]) {
        annotationParagraphMap[annotation.paragraphId] = [];
      }

      annotationParagraphMap[annotation.paragraphId].push(annotation);
    }
  }

  return { annotationMap, annotationParagraphMap, endLineAnnotations };
};
